import React, { useEffect, useState } from "react";
import * as style from "./ValueStreamsPanelContent.module.scss";
import Typography from "../../Components/Common/CprimeText";
import { TextInput, TextArea, Divider } from "cprime-foundational-components";

interface AddApplicationContentProps {
  getData: any;
  nameValueStream: any;
  descriptionValueStream: any;
}

const ValueStreamsPanelContent: React.FC<AddApplicationContentProps> = ({
  getData,
  nameValueStream,
  descriptionValueStream,
}) => {
  const scssClass = style as any;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    getData(name, description);
  }, []);

  return (
    <div className={scssClass.panelContent}>
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>
        Value Streams Details
      </Typography>
      <div className={scssClass.fieldsContent}>
        <TextInput
          value={name}
          className={scssClass.textField}
          style={{ width: "100%" }}
          onChange={(e: any) => {
            setName(e?.target?.value);
            nameValueStream(e?.target?.value);
          }}
          placeholder="Enter Name"
          label="Value Stream Name"
        />
        <TextArea
          label={<>Description</>}
          aria-label="minimum height"
          minRows={3}
          placeholder="Enter Description"
          style={{ width: "99.5%" }}
          value={description}
          onChange={(e) => {
            setDescription(e?.target?.value);
            descriptionValueStream(e?.target?.value);
          }}
          maxLength={500}
        />
      </div>
    </div>
  );
};
export default ValueStreamsPanelContent;
